export default __webpack_public_path__ + "static/media/pagamento-pix.ae1fe546.jpg";